import { ButtonPrimary } from "components/Atoms/Button";
import { PhosphorAirplaneTilt, PhosphorCalendarBlank, PhosphorCar, PhosphorMusicNotes, PhosphorTrain } from "components/Atoms/PhosphorIcon";
import Modal from "components/modal";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { NewPlanningOptions } from "./types";
import { serializeToQueryString } from "utilities/queryString";
import { useOpenNewGroundSidePanel } from "components/SidePanel/GroundTransport/NewGroundSidePanel";
import { useOpenNewFlightSidePanel } from "components/SidePanel/Flight/NewFlightSidePanel";
import { useOpenNewTrainSidePanel } from "components/SidePanel/Train/NewTrainSidePanel";

interface Props {
  onClose: () => void
  isOpen: boolean
  options: NewPlanningOptions | null
}

export const NewPlanningModal = (props: Props) => {
  const openNewGroundTransportSidePanel = useOpenNewGroundSidePanel();
  const openNewFlightSidePanel = useOpenNewFlightSidePanel();
  const openNewTrainSidePanel = useOpenNewTrainSidePanel();

  return <Modal
    isOpen={props.isOpen}
    handleClose={props.onClose}
    displayHeader={false}
    gap="small"
  >
    {site.permissions.show.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={site.currentEnvironment.show.newLabel}
      href={getNewShowRoute(props.options)}
      iconLeft={PhosphorMusicNotes}
      fluid
    />}
    {site.permissions.flight.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={RESX.Flight.NewFlight}
      onClick={() => {
        openNewFlightSidePanel();
        props.onClose();
      }}
      iconLeft={PhosphorAirplaneTilt}
      fluid
    />}
    {site.permissions.train.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={RESX.Train.NewTrainJourney}
      onClick={() => {
        openNewTrainSidePanel();
        props.onClose();
      }}
      iconLeft={PhosphorTrain}
      fluid
    />}
    {site.permissions.groundTransport.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={RESX.GroundTransport.NewGroundTransport}
      onClick={() => {
        openNewGroundTransportSidePanel();
        props.onClose();
      }}
      iconLeft={PhosphorCar}
      fluid
    />}
    {site.permissions.externalCalendar.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={RESX.ExternalCalendar.NewExternalCalendar}
      href={routes.externalCalendar_New().absolute}
      iconLeft={PhosphorCalendarBlank}
      fluid
    />}
    {site.deploymentValues.debug && <div className="flex-column">
      <span>Debug options:</span>
      <div>{JSON.stringify(props.options, null, 2)}</div>
    </div>}
  </Modal>
}

export const getNewShowRoute = (options: NewPlanningOptions | null) => {
  const params = {
    date: options?.date ? options.date.toISOString() : null,
    artistId: options?.artist ? options.artist.artistId.toString() : null
  }
  const query = serializeToQueryString(params);

  return `${routes.show_New().absolute}?${query}`;
}